import { clsx } from 'clsx';
import * as styles from './styles.css';
import * as React from 'react';
import { PROMO_ICON } from '../constants/icons';

export function BonusIcon() {
  return (
    <div className={clsx(styles['container'], styles['star'])}>
      <img src={PROMO_ICON.get('bonus')} className={styles['icon-img']} />
    </div>
  );
}
